import PropTypes from 'prop-types';
import React from 'react';
import { areEqual } from 'react-window';

const propTypes = {
  data: PropTypes.arrayOf(PropTypes.func).isRequired,
  index: PropTypes.number.isRequired,
  style: PropTypes.shape({}).isRequired,
};

const WindowItem = ({ data, index, style }) => data[index](style);

WindowItem.propTypes = propTypes;

export default React.memo(WindowItem, areEqual);
